module.exports = __webpack_public_path__ + "static/img_2-1d65be4c1310aa09f28052ec8f99f1ef.png";